import React, {Component} from 'react';
import PropTypes from 'prop-types';

export default class ResetButton extends Component {

    static propTypes = {
        reset: PropTypes.func,
        filterKey: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
            PropTypes.array
        ]),
    };


    render() {
        const {reset, value, filterKey} = this.props;

        const resetButton = (
            <span className={'resetButtonContainer'}>
                <button onClick={() => reset(filterKey)}>
                    <span className={'buttonText'}>reset</span>
                    <span className={'buttonIcon'}/>
                </button>
            </span>
        );

        return value !== 0 ? resetButton : '';
    }
}



// WEBPACK FOOTER //
// ./src/components/Planner/ResetButton.js